export const About = (props) => {
  return (

    <div className="container">
      <div id="about">
        <h1 className="aboutheader-1">RO Repair Care Number &amp; Service Centre in <br />
          <span className="aboutheader-2"> Bangalore</span>
        </h1>
      </div>

      <div align="center" className="border">
        <img className="img-responsive" src="img/border.jpg" alt='ro service aboutus' />
      </div>
      &nbsp;
      <p style={{ align: "justify" }}><strong>For Any RO Water Purifier Needs in Bangalore and Across India:</strong> If you're facing any issues with your RO water purifier, our dedicated customer support team is just a call away! Bangalore @ 9845479493 from your registered mobile, and you'll get a callback with a unique complaint number. Our skilled technicians will reach out to you the very same day to provide expert repair and service, ensuring your system is up and running in no time.</p>

      <p style={{ align: "justify" }}>As one of the most reliable names in the industry, we take pride in providing top-quality RO systems, trusted by both households and businesses for their efficiency and longevity. With service centers all over India, we offer a range of services including repairs, AMCs, and installations, ensuring your RO purifier operates flawlessly.<br /><br />

        Our technicians are well-trained to handle tasks such as membrane cleaning and general maintenance, either at your location or at our regional centers. We offer complete support for all types of water purification systems, helping you save both time and money while maintaining optimal performance.<br /><br />

        RO Water Purifier Services stands as a leading service provider across India, offering solutions for domestic, commercial, and industrial water treatment. You can trust us to take care of all your RO service needs.<br /><br />

        &nbsp;
      </p>
      <p align="center">
        <a className="btn btn-primary btn-lg" href="tel:9845479493" target="_blank" rel="noreferrer" style={{ fontSize: '24px' }}>Call Now: 9845479493</a>
      </p> 
      <p>For all your RO system needs—from installation to routine service—the RO Repair Care has you covered. If you're facing any issues with your water purifier, our team of skilled technicians is available around the clock. You can reach our 24/7 RO service helpline for support, with coverage extending to almost every state across India. Whether it’s for repairs, maintenance, or servicing, we're here to provide nationwide service anytime you need.<br />
        &nbsp;
      </p>
      <p></p>
      <p></p>
      <p></p>

      <p><strong>RO Repair Care Number Locations RO Contact Number</strong></p>

      <table className="table fntt" style={{ border: "1px solid #ccc" }}>
        <thead>
          <tr>
            <th>RO Customer Care Number All India</th>
            <th>RO Contact Number All India</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>RO Service Center Number All India</td>
            <td><a href="tel:9845479493"><strong>9845479493</strong></a></td>
          </tr>
          <tr>
            <td>RO Service Center Number All India</td>
            <td><a href="tel:9845479493"><strong>9845479493</strong></a></td>
          </tr>

        </tbody>
      </table>

    </div>

  );
};
